<template>
  <div class="wrapper">
    <!--<h3 class="header-wrapper pb-0">-->
      <!--{{ $t('sign_documents_manually') }}-->
    <!--</h3>-->
    <v-layout class="mb-5" justify-center wrap>
      <v-flex class="sign-method-div" xs12 sm6 @click="downloadDocs">
        <img src="../assets/icons/envelope-light.svg" alt="USB drive">
        <br>
        <span class="type-span">
          {{ $t('send_documents_to_manager_for_signing') }}
        </span>
      </v-flex>
      <v-flex class="registration-id-div" xs12>
        <!--<div class="registration-id-div">-->
          <img src="../assets/icons/file-archive-light.svg" class="mr-2" height="28" alt="File archive">
          {{ $t('registration_id') }}: 445798
        <!--</div>-->
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'SendDocumentsToManager',

  methods: {
    downloadDocs() {
      console.log('downloading documents for manual sign...');
      this.$router.push({ name: 'completed' });
    },
  },
};
</script>

<style>
  .type-span {
    font-size: 22px;
  }

  .sign-method-div {
    padding: 8px;
    margin: 0 auto 16px;
    max-width: 320px;
    display: inline-block;
    text-align: center;
  }

  .sign-method-div:hover {
    background: #f3f3f3;
    cursor: pointer;
  }

  .registration-id-div {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px 0;
  }
</style>
